import { styled } from "src/styles/stitches/theme";

export const StyledContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  overflowY: "auto",
});
